import { render, staticRenderFns } from "./SerialnumberSelector.vue?vue&type=template&id=9f166610&"
import script from "./SerialnumberSelector.ts?vue&type=script&lang=js&"
export * from "./SerialnumberSelector.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports